import { Formik } from "formik";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "./../../../constants/pages";
import { useNavigate } from "react-router-dom";
import { ButtonFooter } from "../../../components";
import { useAlert, useAxios } from "../../../hooks";
import convertDateToBackendFormat from "../../push notification components/push notification details components/convertDateToBackendFormat";

export default function Form({ formData, editState, setEditState }) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeBot } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        let data = Object.keys(formData)
          .map((item, index) => {
            if (
              item != "broadcastID" &&
              item != "stagesCount" &&
              item != "segmentID" &&
              item != "templateID" &&
              item != "broadcastName" &&
              item != "button_variable"
            ) {
              return {
                schedule_date: convertDateToBackendFormat(
                  formData[item].broadcastDate
                ),
                schedule_time: formData[item].broadcastTime,
                template_id: formData[item].templateID,
                body_variable: formData[item].body_variable,
                header_variable: formData[item].header_variable,
                button_variable: formData[item].button_variable,
              };
            }
          })
          .filter((item) => {
            return item?.schedule_time;
          });

        axios({
          url: "/reminders/stages/attach/" + activeBot.ID,
          method: "POST",
          data: { broadcast_id: formData.broadcastID, stages: data },
        }).then((response) => {
          if (response.status) {
            navigate(pages.reminderBroadcastList.route);

            dispatch(
              alert({
                type: "success",
                message: response.message.displayMessage,
              })
            );
          }

          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <Fragment>
          <FormDisplay
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />

          <ButtonFooter
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Fragment>
      )}
    </Formik>
  );
}
